import { render } from "./PlanetaryPositions.vue?vue&type=template&id=6d84b1af&scoped=true"
import script from "./PlanetaryPositions.vue?vue&type=script&lang=js"
export * from "./PlanetaryPositions.vue?vue&type=script&lang=js"

import "./PlanetaryPositions.vue?vue&type=style&index=0&id=6d84b1af&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d84b1af"]])

export default __exports__